import _ from 'lodash';
import service from '../../api/index.js';

const { loginService } = service;

// console.log('loginService', Object.keys(loginService))

const state = {
  userinfo: {},
  smsInfo: {},
  redirectUrl: ''
};

const actions = {
  logout({ commit }, params) {
    return new Promise((resolve, reject) => {
      loginService.logout(params).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      })
    });
  },
  login({ commit }, params) {
    return new Promise((resolve, reject) => {
      loginService.login(params).then(res => {
        const { data } = res;
        commit('setUserinfo', data);
        return resolve(data);
      }).catch(err => {
        const data = _.get(err, 'response.data');
        return reject(data);
      })
    })
  },
  createSlideCaptcha({ commit }, params) {
    return new Promise((resolve, reject) => {
      loginService.createSlideCaptcha(params).then(res => {
        const { data } = res;
        return resolve(data);
      }).catch(err => {
        return reject(err);
      })
    })
  },
  creatCaptcha({ commit }, params) {
    return new Promise((resolve, reject) => {
      loginService.creatCaptcha(params).then(res => {
        const { data } = res;
        return resolve(data);
      }).catch(err => {
        return reject(err)
      })
    })
  },
  sendSmsCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      loginService.sendSmsCode(params).then(res => {
        const { data } = res;
        commit('setSmsInfo', data);
        return resolve(data);
      }).catch(err => {
        return reject(err)
      })
    })
  },
  loginBySms({ commit }, params) {
    return new Promise((resolve, reject) => {
      loginService.loginBySms(params).then(res => {
        const { data } = res;
        commit('setLoginUserinfo', data);
        return resolve(data);
      }).catch(err => {
        const data = _.get(err, 'response.data');
        if (data) {
          return reject(data)
        }
        return reject(err)
      })
    })
  },
  loginByTotp({ commit }, params) {
    return new Promise((resolve, reject) => {
      loginService.loginByTotp(params).then(res => {
        const { data } = res;
        commit('setLoginUserinfo', data);
        return resolve(data);
      }).catch(err => {
        const data = _.get(err, 'response.data');
        if (data) {
          return reject(data)
        }
        return reject(err)
      })
    })
  }
};

const mutations = {
  setUserinfo(state, payload = {}) {
    state.userinfo = payload;
  },
  setLoginUserinfo(state, payload = {}) {
    state.userinfo = Object.assign({}, state.userinfo, payload);
  },
  setSmsInfo(state, payload = {}) {
    state.smsInfo = payload;
  },
  setRedirectUrl(state, url) {
    state.redirectUrl = url;
    localStorage.setItem('redirectSourceUrl', url);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
